import { allCountries } from "country-region-data";

/**
 * Get regions/states for a given country name
 * @param {string} countryName - The name of the country
 * @returns {Promise<Array>} Array of region/state names sorted alphabetically
 */
export const getRegionsByCountry = async (countryName) => {
  try {
    if (!countryName) return [];

    // Find country in allCountries
    let regions = [];
    
    for (let i = 0; i < allCountries.length; i++) {
      const [country, countryCode, countryRegions] = allCountries[i];
      
      // Match by country name (case-insensitive)
      if (country.toLowerCase() === countryName.toLowerCase()) {
        // Extract region names from the data structure
        // allCountries format: [countryName, countryCode, [[regionName, regionCode], [regionName, regionCode], ...]]
        regions = (countryRegions || []).map((region) => {
          // Region can be either just a name string or [name, code] array
          return typeof region === "string" ? region : region[0];
        });
        break;
      }
    }

    return regions.sort((a, b) => a.localeCompare(b));
  } catch (error) {
    console.error("Error fetching regions:", error);
    return [];
  }
};

/**
 * Get all countries
 * @returns {Array} Array of country names
 */
export const getAllCountries = () => {
  try {
    return (allCountries || []).map((item) => item[0]);
  } catch (error) {
    console.error("Error fetching countries:", error);
    return [];
  }
};

